<template>
  <fieldset class="radios-fieldset" :disabled="disabled">
    <legend v-if="legend">
      {{ legend }}
    </legend>
    <CheckRadio
      v-for="(option, i) in radioOptions"
      :key="'radio-set-' + i"
      :error-message="false"
      type="radio"
      :value="option"
      :name="optionSetName"
      :radio-checked="state.radioChecked"
      :emit-input-change="'radio-selected'"
      :not-valid-override="state.notValid"
      @radio-selected="radioChanged"
    >
      {{ option }}
    </CheckRadio>
    <div v-if="state.notValid" class="checkradio-invalid-container">
      <ErrorWarningFill />
      <p>
        <slot name="checkboxError"> Radios error message. </slot>
      </p>
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import { ChangePayload } from '~/types/solo-input';

const emit = defineEmits(['radio-selected', 'radio-changed', 'sort-change']);
type RadioChangeEmits = 'radio-selected' | 'radio-changed' | 'sort-change';

const props = defineProps({
  emitRadioChanged: {
    type: String as () => RadioChangeEmits,
    default: undefined,
  },
  radioOptions: {
    type: Array as () => string[],
    required: true,
  },
  optionSetName: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  legend: {
    type: String,
    default: undefined,
  },
  notValidOverride: {
    type: Boolean,
    default: false,
  },
});

const state = reactive({
  radioChecked: '',
  notValid: props.notValidOverride,
});

function radioChanged(e: ChangePayload) {
  state.radioChecked = e.value;
  if (props.emitRadioChanged) {
    emit(props.emitRadioChanged, e);
  }
}
</script>

<style lang="scss" scoped>
.radios-fieldset {
  border-radius: 4px;
  box-sizing: border-box;
}

.checkradio-invalid-container {
  align-items: center;
  display: flex;
  margin-top: 0.45rem;
  color: $color-danger-dark;
  fill: $color-danger-dark;

  :deep(svg) {
    height: 1rem;
    margin-right: 0.25rem;
    width: 1rem;
  }

  p {
    margin: 0;
  }
}
</style>
